// src/assets/data/cursos/finanzas-personales/modulo-7.js
import banner from "../../../courses/finanzas.webp";

const modulo7 = {
  courseId: "finanzas-personales",
  id: "modulo-7",
  title: "🧪 MÓDULO 7: Evaluación Final",
  estimatedDuration: "30–45 minutos",
  format: "Examen final en línea + reflexión opcional",
  bannerUrl: banner,
  sections: [
    {
      id: "objetivos",
      navLabel: "Objetivos",
      title: "🎯 Objetivos del módulo",
      content: [
        "Verificar que comprendes los conceptos clave del curso.",
        "Validar que puedes aplicar lo aprendido en tu vida diaria.",
        "Dar el paso final para obtener tu Certificado Profesional ZyVerse.",
      ],
    },
    {
      id: "incluye",
      navLabel: "Temas Evaluación",
      title: "✅ ¿Qué incluye esta evaluación?",
      content: [
        "📌 Examen final",
        {
          type: "list",
          items: [
            "20 preguntas de opción múltiple",
            "Basadas en los 6 módulos anteriores",
            "Temas: presupuesto, ahorro, crédito, inversión, consumo y hábitos",
            "Duración estimada: 25–30 minutos",
            "Calificación mínima aprobatoria: 60% de aciertos",
          ],
        },
      ],
    },
    {
      id: "examen",
      navLabel: "Examen Final",
      title: "📝 EXAMEN FINAL",
      questions: [
        {
          id: "q1",
          question:
            "¿Cuál es el primer paso para empezar a organizar tus finanzas personales?",
          options: [
            { key: "a", text: "Invertir en CETES" },
            { key: "b", text: "Hacer un presupuesto" },
            { key: "c", text: "Abrir una tarjeta de crédito" },
            { key: "d", text: "Comprar en efectivo" },
          ],
          correct: "b",
        },
        {
          id: "q2",
          question:
            "¿Cuál de las siguientes afirmaciones sobre el presupuesto es correcta?",
          options: [
            { key: "a", text: "Solo sirve si ganas mucho dinero" },
            { key: "b", text: "Te ayuda a planear y controlar tus gastos" },
            { key: "c", text: "Es lo mismo que ahorrar" },
            { key: "d", text: "Solo lo usan las empresas" },
          ],
          correct: "b",
        },
        {
          id: "q3",
          question: "¿Qué es el gasto hormiga?",
          options: [
            { key: "a", text: "Grandes compras mensuales" },
            { key: "b", text: "Gastos pequeños que se repiten y se acumulan" },
            { key: "c", text: "Gastos de emergencia" },
            { key: "d", text: "Dinero prestado" },
          ],
          correct: "b",
        },
        {
          id: "q4",
          question: "¿Cuál es un ejemplo de gasto fijo?",
          options: [
            { key: "a", text: "Cine" },
            { key: "b", text: "Cafés" },
            { key: "c", text: "Renta" },
            { key: "d", text: "Snacks" },
          ],
          correct: "c",
        },
        {
          id: "q5",
          question: "¿Qué representa la letra “M” en una meta SMART?",
          options: [
            { key: "a", text: "Medible" },
            { key: "b", text: "Mínima" },
            { key: "c", text: "Mensual" },
            { key: "d", text: "Monetaria" },
          ],
          correct: "a",
        },
        {
          id: "q6",
          question:
            "¿Cuál es el porcentaje recomendado de uso del crédito disponible?",
          options: [
            { key: "a", text: "90%" },
            { key: "b", text: "100%" },
            { key: "c", text: "No más del 30%" },
            { key: "d", text: "10%" },
          ],
          correct: "c",
        },
        {
          id: "q7",
          question: "¿Qué es el buró de crédito?",
          options: [
            { key: "a", text: "Una empresa de tarjetas" },
            {
              key: "b",
              text: "Una institución que registra tu historial financiero",
            },
            { key: "c", text: "Una app de pagos" },
            { key: "d", text: "Un banco digital" },
          ],
          correct: "b",
        },
        {
          id: "q8",
          question: "¿Cuál es una señal de una oferta de crédito riesgosa?",
          options: [
            { key: "a", text: "Requiere historial" },
            { key: "b", text: "Promete dinero fácil sin requisitos" },
            { key: "c", text: "Tiene tasa fija" },
            { key: "d", text: "Te pide comprobantes" },
          ],
          correct: "b",
        },
        {
          id: "q9",
          question: "¿Qué es el interés compuesto?",
          options: [
            { key: "a", text: "Ganar dinero por invitar amigos" },
            { key: "b", text: "Generar intereses sobre intereses anteriores" },
            { key: "c", text: "Un tipo de impuesto" },
            { key: "d", text: "Pago por usar efectivo" },
          ],
          correct: "b",
        },
        {
          id: "q10",
          question: "¿Cuál de estas opciones es una inversión de bajo riesgo?",
          options: [
            { key: "a", text: "Criptomonedas" },
            { key: "b", text: "CETES" },
            { key: "c", text: "Startups" },
            { key: "d", text: "Bolsa extranjera" },
          ],
          correct: "b",
        },
        {
          id: "q11",
          question: "¿Qué dice la Ley del Riesgo y Rentabilidad?",
          options: [
            { key: "a", text: "Mayor ganancia implica mayor riesgo" },
            { key: "b", text: "Solo los ricos ganan" },
            { key: "c", text: "Invertir siempre es seguro" },
            { key: "d", text: "El riesgo no influye en el rendimiento" },
          ],
          correct: "a",
        },
        {
          id: "q12",
          question:
            "Según la regla 110, si tienes 20 años, ¿cuánto podrías invertir en instrumentos de riesgo?",
          options: [
            { key: "a", text: "80%" },
            { key: "b", text: "60%" },
            { key: "c", text: "90%" },
            { key: "d", text: "30%" },
          ],
          correct: "c",
        },
        {
          id: "q13",
          question: "¿Qué significa consumir responsablemente?",
          options: [
            { key: "a", text: "Solo comprar productos ecológicos" },
            { key: "b", text: "Gastar solo en efectivo" },
            { key: "c", text: "Comprar con conciencia y alineado a tus metas" },
            { key: "d", text: "Dejar de consumir por completo" },
          ],
          correct: "c",
        },
        {
          id: "q14",
          question: "¿Qué técnica ayuda a reducir compras impulsivas?",
          options: [
            { key: "a", text: "Gasto libre" },
            { key: "b", text: "Lista de espera de 72 horas" },
            { key: "c", text: "Comprar con amigos" },
            { key: "d", text: "Usar varias tarjetas" },
          ],
          correct: "b",
        },
        {
          id: "q15",
          question: "¿Qué representa la cima de la pirámide de Maslow?",
          options: [
            { key: "a", text: "Comida y transporte" },
            { key: "b", text: "Autorrealización" },
            { key: "c", text: "Seguridad financiera" },
            { key: "d", text: "Familia y amigos" },
          ],
          correct: "b",
        },
        {
          id: "q16",
          question: "¿Qué puedes hacer para empezar a ahorrar con propósito?",
          options: [
            { key: "a", text: "Guardar lo que sobre" },
            { key: "b", text: "Evitar gastar" },
            {
              key: "c",
              text: "Definir una meta SMART y separar una cantidad fija",
            },
            { key: "d", text: "Invertir todo en cripto" },
          ],
          correct: "c",
        },
        {
          id: "q17",
          question: "¿Qué hace el presupuesto de gustitos?",
          options: [
            { key: "a", text: "Elimina gastos innecesarios" },
            { key: "b", text: "Te impide comprar cosas" },
            { key: "c", text: "Permite disfrutar sin afectar tus finanzas" },
            { key: "d", text: "Aumenta el límite de tu tarjeta" },
          ],
          correct: "c",
        },
        {
          id: "q18",
          question:
            "¿Qué herramienta te ayuda a observar tus hábitos financieros?",
          options: [
            { key: "a", text: "Hoja de seguimiento de hábitos" },
            { key: "b", text: "Aplicaciones de clima" },
            { key: "c", text: "Registro civil" },
            { key: "d", text: "Cuadro de honor" },
          ],
          correct: "a",
        },
        {
          id: "q19",
          question: "¿Qué incluye el certificado profesional ZyVerse?",
          options: [
            { key: "a", text: "Bono económico" },
            { key: "b", text: "Tarjeta de débito" },
            { key: "c", text: "Nombre, fecha, curso y código verificador" },
            { key: "d", text: "Seguro de vida" },
          ],
          correct: "c",
        },
        {
          id: "q20",
          question: "¿Qué frase resume mejor la filosofía del curso?",
          options: [
            { key: "a", text: "“Haz dinero rápido.”" },
            {
              key: "b",
              text: "“Decidir mejor es más poderoso que ganar más.”",
            },
            { key: "c", text: "“Compra sin miedo.”" },
            { key: "d", text: "“Endeudarse es inevitable.”" },
          ],
          correct: "b",
        },
      ],
    },
    {
      id: "reflexion",
      navLabel: "Reflexión Final",
      title: "💡 Reflexión Final (opcional)",
      content: [
        "¿Qué aprendí y cómo lo aplicaré?",
        "Aunque no es obligatoria, se recomienda enviar una reflexión escrita o grabada para enriquecer tu proceso de aprendizaje. Puede ayudarte a integrar mejor los conceptos en tu vida personal.",
      ],
    },
    {
      id: "frase",
      navLabel: "Frase de cierre",
      title: "💬 Frase de cierre",
      content: [
        "“Este curso termina aquí, pero tu camino financiero apenas comienza.”",
      ],
    },
  ],
};

export default modulo7;
